// extracted by mini-css-extract-plugin
export default {"musicWishRow":"MusicWishForm_musicWishRow__0NLQm"};